<button mat-menu-item
	(click)="inviteUsers()"
	class="invite-users-btn">
	<span translate="invite-users"></span>
</button>
<button mat-menu-item
	(click)="manageUsers()"
	class="manage-users-btn">
	<span translate="course-menu_manage-users"></span>
</button>
<button mat-menu-item
	*ngIf="userService.currentUser.is_root_user"
	(click)="openAccountAdminSettings()"
	class="account-admin-btn">
	<span translate="group-menu-dropdown-platform-admin-account-settings"></span>
</button>
<button mat-menu-item
	*ngIf="userService.currentUser.is_root_owner"
	(click)="deleteAccount()"
	class="delete-account-btn">
	<span translate="course-menu_delete-account"></span>
</button>
